import { useIsMultiEntityEnabled } from '@webapp/core/hooks/useIsMultiEntityEnabled'
import { useQueryUserLegalEntities } from '../../models/useQueryUserLegalEntities'

/**
 * The user's assigned Legal Entities and the one host pages should preselect,
 * with the Multi-Entity gate alongside. Whether to show a control, and what
 * to apply when it is hidden, is each host's call.
 */
export const useGetUserLegalEntitiesPresenter = () => {
  const isMultiEntityEnabled = useIsMultiEntityEnabled()
  const { legalEntities, defaultLegalEntity } = useQueryUserLegalEntities()

  return {
    data: { legalEntities, defaultLegalEntity },
    states: { isMultiEntityEnabled },
  }
}
